import React from 'react'
import InputFieldUI from './InputFieldUI'
import './InputTextArea.css'

const InputTextAreaUI = ({context, type, name, value, onChange,
    // label
    label, help, messageList, labelKey, helpKey,
    // behavior
    required, autoFocus, disabled, error}) =>
  <InputFieldUI className='w_input_txtarea' name={name} required={required}
    label={label} help={help} messageList={messageList} labelKey={labelKey} helpKey={helpKey}>
    <textarea name={name} onChange={onChange} 
      autoFocus={autoFocus} disabled={disabled}
      className={error ? 'hasError' : ''}
      value={value}
    >
      {/*value*/}
    </textarea>
  </InputFieldUI>

export default InputTextAreaUI
